function retryPatchSetVariant(attempt = 1) {
  const log = `[AJAX Included Products Alpine Patch, attempt ${attempt}]`;

  try {
    const root = document.querySelector('[x-data*="handleVariant"]');
    if (!root) return setTimeout(() => retryPatchSetVariant(attempt + 1), 300);

    if (!window.Alpine || typeof window.Alpine.$data !== "function") {
      return setTimeout(() => retryPatchSetVariant(attempt + 1), 300);
    }

    const state = window.Alpine.$data(root);
    if (!state || typeof state.setVariant !== "function") {
      return setTimeout(() => retryPatchSetVariant(attempt + 1), 300);
    }

    if (state.setVariant._patchedIncludedProducts) return;

    // ---------------------------------------------------------------------
    // Fetch + swap: pulls section_id=included-products-only and replaces
    // [data-included-products-only] innerHTML, then re-inits Alpine on it.
    // ---------------------------------------------------------------------
    async function fetchAndSwapIncludedProducts(existingEl, variantId) {
      const url = new URL(window.location.href);
      url.searchParams.set("variant", String(variantId));
      url.searchParams.set("section_id", "included-products-only");
      url.searchParams.set("_", String(Date.now())); // cache-bust

      const r = await fetch(url.toString(), { headers: { Accept: "text/html" } });
      if (!r.ok) throw new Error(`status ${r.status}`);
      const html = await r.text();

      const tmp = document.createElement("div");
      tmp.innerHTML = html;

      const incoming = tmp.querySelector("[data-included-products-only]");
      if (!incoming) return;

      existingEl.innerHTML = incoming.innerHTML;

      try {
        if (window.Alpine && typeof window.Alpine.initTree === "function") {
          window.Alpine.initTree(existingEl);
        }
      } catch (_) {}
    }

    // ---------------------------------------------------------------------
    // Fade wrapper (match gallery) + prevent card flash + fade cards in
    // Wrapper fade: 0.10 out, 0.40 in (same as gallery).
    // Cards: opacity-only (no translate).
    // Prevent flash: .is-swapping class hides cards before swap can paint.
    // ---------------------------------------------------------------------
    function fadeLikeGalleryWithCards(wrapperEl, swapTask) {
      if (!wrapperEl) return;

      // Avoid stacking if user clicks quickly
      if (wrapperEl._includedBusy) return;
      wrapperEl._includedBusy = true;

      const hasGsap = typeof window.gsap !== "undefined";

      const runSwap = async () => {
        // Lock height to avoid page jump while replacing DOM
        const prevH = wrapperEl.offsetHeight;
        if (prevH) wrapperEl.style.minHeight = `${prevH}px`;

        // Hard-hide cards BEFORE swap (prevents 1-frame flash)
        wrapperEl.classList.add("is-swapping");

        await swapTask();

        const cards = wrapperEl.querySelectorAll(".included-product-item");

        // Ensure cards are still hidden immediately after swap
        if (hasGsap) {
          window.gsap.set(cards, { autoAlpha: 0, overwrite: true });
        } else {
          cards.forEach((c) => { c.style.opacity = "0"; });
        }

        // Optional: wait for image decode (reduces “pop” from late rendering)
        const imgs = Array.from(wrapperEl.querySelectorAll("img"));
        try {
          await Promise.all(
            imgs.map((img) => (img.decode ? img.decode().catch(() => {}) : Promise.resolve()))
          );
        } catch (_) {}

        // Fade cards in (opacity only)
        if (hasGsap) {
          window.gsap.to(cards, {
            autoAlpha: 1,
            duration: 0.25,
            ease: "power1.out",
            stagger: 0.03,
            overwrite: true
          });
        } else {
          requestAnimationFrame(() => {
            cards.forEach((c) => {
              c.style.transition = "opacity 200ms ease";
              c.style.opacity = "1";
            });
          });
        }

        // Release minHeight after swap is settled
        requestAnimationFrame(() => {
          wrapperEl.style.minHeight = "";
        });
      };

      // If GSAP is not available, do swap + card fade without wrapper fade
      if (!hasGsap) {
        runSwap()
          .catch((e) => console.error(log, e))
          .finally(() => {
            wrapperEl.classList.remove("is-swapping");
            wrapperEl._includedBusy = false;
          });
        return;
      }

      // Wrapper fade matches gallery; remove is-swapping only when wrapper is visible
      window.gsap
        .timeline({
          onComplete: () => {
            wrapperEl._includedBusy = false;
          }
        })
        .to(wrapperEl, { autoAlpha: 0, duration: 0.10, ease: "power1.out" })
        .add(() => runSwap().catch((e) => console.error(log, e)))
        .to(wrapperEl, {
          autoAlpha: 1,
          duration: 0.40,
          ease: "power1.inOut",
          onComplete: () => wrapperEl.classList.remove("is-swapping")
        });
    }

    // ---------------------------------------------------------------------
    // Patch setVariant
    // ---------------------------------------------------------------------
    const original = state.setVariant.bind(state);

    state.setVariant = function patchedSetVariant(arg = true) {
      const ret = original(arg);

      if (!this.isProductPage) return ret;

      const variantId = this.product?.selected_or_first_available_variant?.id;
      if (!variantId) return ret;

      const existing = document.querySelector("[data-included-products-only]");
      if (!existing) return ret;

      fadeLikeGalleryWithCards(existing, async () => {
        await fetchAndSwapIncludedProducts(existing, variantId);
      });

      return ret;
    };

    state.setVariant._patchedIncludedProducts = true;
  } catch (err) {
    console.error(log, err);
    setTimeout(() => retryPatchSetVariant(attempt + 1), 300);
  }
}

document.addEventListener("alpine:init", () => retryPatchSetVariant(1));
document.addEventListener("DOMContentLoaded", () => retryPatchSetVariant(1));